import type { BrandingData } from "@saas/shared/types/brand";

/** A partial branding change: omitted or `undefined` keeps the saved value, `null` clears it. */
export type BrandingUpdate = { [Key in keyof BrandingData]?: BrandingData[Key] | null };

const DEFAULT_BRANDING: BrandingData = {
	enabled: false,
	primaryColor: "#3B82F6",
	secondaryColor: "#EF4444",
	gradientFromColor: "#F3F8FF",
	gradientToColor: "#F8F8FF",
};

/**
 * Branding is saved as a single record, so each form's change is merged onto the saved
 * values to stop one form wiping fields owned by another (such as the header logo).
 */
export function mergeBrandingUpdate(current: BrandingData | undefined, update: BrandingUpdate): BrandingData {
	const merged: Record<string, unknown> = { ...DEFAULT_BRANDING, ...current };
	for (const [key, value] of Object.entries(update)) {
		if (value === null) {
			delete merged[key];
		} else if (value !== undefined) {
			merged[key] = value;
		}
	}
	return merged as unknown as BrandingData;
}
